// updateOperationLivestream.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
const selectPath = ['liveStream'];
/**
 * Update operation stream data
 * @kind action
 * @param {string} {activeStreamId} - active stream id.
 * @param {string} {selectedGiftType} - selected gift type.
 * @return {Promise} Action promise.
 */
const updateOperationLivestream =
  ({ activeStreamId, selectedGiftType }) =>
  async dispatch => {
    let data = {};

    if (activeStreamId != null) {
      data.activeStreamId = activeStreamId;
    }
    if (selectedGiftType != null) {
      data.selectedGiftType = selectedGiftType;
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath,
        data,
      },
    });
  };

export default updateOperationLivestream;
